import { Company_User_Role } from "@generated/graphql";
import ROUTES, { isPublicAuthRoute } from "constants/routes";

export enum RouteAccessState {
  ALLOWED = "allowed",
  FORBIDDEN = "forbidden",
  STUB = "stub",
}

export const STUB_ROLES = [Company_User_Role.Administrator, Company_User_Role.Reviewer];
export const WORKSPACE_ROLES = [Company_User_Role.Supervisor, Company_User_Role.Hr, Company_User_Role.Methodologist];

const PROFILE_PATH = `/${ROUTES.PROFILE}`;
const COMPANY_PATH = `/${ROUTES.COMPANY}`;
const CANDIDATE_PATH = `/${ROUTES.CANDIDATE}`;
const VACANCIES_PATH = `/${ROUTES.VACANCIES}`;

const WORKSPACE_PATHS = [
  `/${ROUTES.COMPETENCE_MAPS}`,
  `/${ROUTES.KNOWLEDGE_BLOCKS}`,
  `/${ROUTES.TESTING}`,
  `/${ROUTES.SKILL}`,
  `/${ROUTES.CANDIDATE}`,
  `/${ROUTES.QUESTION}`,
  `/${ROUTES.VACANCIES}`,
];

const isPathMatch = (pathname: string, path: string) => pathname === path || pathname.startsWith(`${path}/`);

export const isProfileRoute = (pathname: string) => isPathMatch(pathname, PROFILE_PATH);

export const isCompanyRoute = (pathname: string) => isPathMatch(pathname, COMPANY_PATH);

export const isCandidateRoute = (pathname: string) => isPathMatch(pathname, CANDIDATE_PATH);

export const isVacanciesRoute = (pathname: string) => isPathMatch(pathname, VACANCIES_PATH);

export const isWorkspaceRoute = (pathname: string) => WORKSPACE_PATHS.some((path) => isPathMatch(pathname, path));

export const getRouteAccessState = (pathname: string, role: Company_User_Role | undefined): RouteAccessState => {
  if (isPublicAuthRoute(pathname) || isProfileRoute(pathname)) {
    return RouteAccessState.ALLOWED;
  }

  if (!role) {
    return RouteAccessState.FORBIDDEN;
  }

  if (STUB_ROLES.includes(role)) {
    return RouteAccessState.STUB;
  }

  if (isCompanyRoute(pathname)) {
    return role === Company_User_Role.Supervisor ? RouteAccessState.ALLOWED : RouteAccessState.FORBIDDEN;
  }

  if (role === Company_User_Role.Methodologist && (isCandidateRoute(pathname) || isVacanciesRoute(pathname))) {
    return RouteAccessState.FORBIDDEN;
  }

  if (isWorkspaceRoute(pathname)) {
    return WORKSPACE_ROLES.includes(role) ? RouteAccessState.ALLOWED : RouteAccessState.FORBIDDEN;
  }

  return RouteAccessState.ALLOWED;
};
